import { HOMEPAGE_V2 } from "@config/testIds/app";

import { SERVICE_TYPE } from "@typings/globals";

import { TranslateFunction } from "@hooks/useTranslate";

import { ServiceOption } from "./ServiceField.types";

const servicesTranslations: Record<SERVICE_TYPE, string> = {
  [SERVICE_TYPE.HOME_CLEANING]: "batmaid_pwa_generic.service_type_b2c",
  [SERVICE_TYPE.END_OF_TENANCY]: "batmaid_pwa_generic.service_type_eot",
  [SERVICE_TYPE.B2B]: "batmaid_pwa_generic.service_type_b2b",
};

export const getServicesOptions = (
  translate: TranslateFunction,
  services: SERVICE_TYPE[],
): ServiceOption[] => {
  return services.map(service => ({
    value: service,
    label: translate(servicesTranslations[service]),
    testId: `${HOMEPAGE_V2.HERO_SERVICE_OPTION}--${service}`,
  }));
};
